import * as React from "react";
import type { SVGProps } from "react";
const SvgElectricityHollow = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 33 32" {...props}>
    <path
      stroke="currentColor"
      strokeWidth={2}
      d="M9.659 18.237a1.002 1.002 0 0 1-.838-1.548l8.732-13.387a.75.75 0 0 1 1.366.54l-1.653 9.366h6.077a1 1 0 0 1 .816 1.578l-9.87 13.933a.75.75 0 0 1-1.335-.633l2.736-9.85H9.66l-.001.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgElectricityHollow;
